import { cn } from "../../lib/utils";

/**
 * Small bordered spinner. Token-driven (border + primary), theme-aware.
 * Replaces the bespoke `.storycraft-spinner` and ad-hoc inline spinners.
 */
export function Spinner({
  size = 14,
  className,
  "aria-label": ariaLabel = "Loading",
}: {
  size?: number;
  className?: string;
  "aria-label"?: string;
}) {
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      className={cn(
        "inline-block shrink-0 animate-spin rounded-full border-2 border-border border-t-primary",
        className
      )}
      style={{ width: size, height: size }}
    />
  );
}
